import { render, staticRenderFns } from "./observation-modal.component.vue?vue&type=template&id=b83428de&scoped=true&"
import script from "./observation-modal.component.vue?vue&type=script&lang=ts&"
export * from "./observation-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./observation-modal.component.vue?vue&type=style&index=0&id=b83428de&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83428de",
  null
  
)

export default component.exports